/**
 * Created by Owner on 2016/10/20.
 *
 */

import { TranslateService } from "ng2-translate";

export class AppConfig {
    // switchLanguage(language: string) {
    //     translate.use(language);
    // }

    static Version: string = "v1.0";
    static appName: string = "LOTO99";

    // status: 0 => old game, status: 1 => new game, status: 2 => hot game
    static LotteryList = (translate: TranslateService) => [
        {
            label: translate.instant('SIEU_TOC'),
            clsItem: "xososieutoc",
            status: 2,
            collapse: false,
            tabMath: [3] as any,
            children: [
                {
                    id: '50',
                    name: 'MMC',
                    title: translate.instant('1_GIAY'),
                    description: translate.instant('MO_THUONG_NGAY_LAP_TUC'),
                    src: 'xs1s'
                },
                {
                    id: '100',
                    name: 'Jz45',
                    title: translate.instant('45_GIAY'),
                    description: translate.instant('MO_THUONG_MOI_45_GIAY'),
                    src: 'xs45s'
                },
                {
                    id: '101',
                    name: 'CSSSC',
                    title: translate.instant('1_PHUT'),
                    description: translate.instant('MO_THUONG_MOI_1_PHUT'),
                    src: 'xs1m'
                },
                {
                    id: '102',
                    name: 'PHP',
                    title: translate.instant('1_5_PHUT'),
                    description: translate.instant('MO_THUONG_MOI_1_5_PHUT'),
                    src: 'xs1m30s'
                },
                {
                    id: '103',
                    name: 'SSCBF',
                    title: translate.instant('2_PHUT'),
                    description: translate.instant('MO_THUONG_MOI_2_PHUT'),
                    src: 'xs2m'
                },
                {
                    id: '104',
                    name: 'CqSSC',
                    title: translate.instant('5_PHUT'),
                    description: translate.instant('MO_THUONG_MOI_5_PHUT'),
                    src: 'xs5m'
                }
            ]
        },
        {
            label: "Miền Bắc",
            clsItem: "xosomienbac",
            status: 0,
            collapse: false,
            tabMath: [3] as any,
            children: [
                {
                    id: '200',
                    name: 'MB',
                    title: 'Miền Bắc 18h14',
                    description: 'Hàng ngày',
                    src: 'mienbac'
                },
                {
                    id: '201',
                    name: 'MBDB',
                    title: 'Đặc Biệt 18h25',
                    description: 'Hàng ngày',
                    src: 'mienbacdacbiet'
                }
            ]
        },

        {
            label: translate.instant('MIEN_TRUNG'),
            clsItem: "xosomientrung",
            status: 0,
            hasCollapse: true,
            isCollapse: true,
            tabMath: [3] as any,
            children: [
                {
                    id: '126',
                    name: 'VN',
                    title: translate.instant('THUA_THIEN_HUE'),
                    description: translate.instant('THU_2'),
                    src: 'hue'
                },
                {
                    id: '127',
                    name: 'VN',
                    title: translate.instant('PHU_YEN'),
                    description: translate.instant('THU_2'),
                    src: 'phuyen'
                },
                {
                    id: '128',
                    name: 'VN',
                    title: translate.instant('DAC_LAC'),
                    description: translate.instant('THU_3'),
                    src: 'daclac'
                },
                {
                    id: '129',
                    name: 'VN',
                    title: translate.instant('QUANG_NAM'),
                    description: translate.instant('THU_3'),
                    src: 'quangnam'
                },
                {
                    id: '130',
                    name: 'VN',
                    title: translate.instant('DA_NANG'),
                    description: translate.instant('THU_4_THU_7'),
                    src: 'danang'
                },
                {
                    id: '131',
                    name: 'VN',
                    title: translate.instant('KHANH_HOA'),
                    description: translate.instant('THU_4_CHU_NHAT'),
                    src: 'khanhhoa'
                },
                {
                    id: '132',
                    name: 'VN',
                    title: translate.instant('BINH_DINH'),
                    description: translate.instant('THU_5'),
                    src: 'binhdinh'
                },
                {
                    id: '133',
                    name: 'VN',
                    title: translate.instant('QUANG_TRI'),
                    description: translate.instant('THU_5'),
                    src: 'quangtri'
                },
                {
                    id: '134',
                    name: 'VN',
                    title: translate.instant('QUANG_BINH'),
                    description: translate.instant('THU_5'),
                    src: 'quangbinh'
                },
                {
                    id: '135',
                    name: 'VN',
                    title: translate.instant('GIA_LAI'),
                    description: translate.instant('THU_6'),
                    src: 'gialai'
                },
                {
                    id: '136',
                    name: 'VN',
                    title: translate.instant('NINH_THUAN'),
                    description: translate.instant('THU_6'),
                    src: 'ninhthuan'
                },
                {
                    id: '137',
                    name: 'VN',
                    title: translate.instant('QUANG_NGAI'),
                    description: translate.instant('THU_7'),
                    src: 'quangngai'
                },
                {
                    id: '138',
                    name: 'VN',
                    title: translate.instant('DAC_NONG'),
                    description: translate.instant('THU_7'),
                    src: 'dacnong'
                },
                {
                    id: '139',
                    name: 'VN',
                    title: translate.instant('KON_TUM'),
                    description: translate.instant('CHU_NHAT'),
                    src: 'kontum'
                }
            ]
        },
        {
            label: translate.instant('MIEN_NAM'),
            clsItem: "xosomiennam",
            status: 0,
            hasCollapse: true,
            isCollapse: true,
            tabMath: [3] as any,
            children: [
                {
                    id: '105',
                    name: 'VN',
                    title: translate.instant('HO_CHI_MINH'),
                    description: translate.instant('THU_2_THU_7'),
                    src: 'hcm'
                },
                {
                    id: '106',
                    name: 'VN',
                    title: translate.instant('DONG_THAP'),
                    description: translate.instant('THU_2'),
                    src: 'dongthap'
                },
                {
                    id: '107',
                    name: 'VN',
                    title: translate.instant('CA_MAU'),
                    description: translate.instant('THU_2'),
                    src: 'camau'
                },
                {
                    id: '108',
                    name: 'VN',
                    title: translate.instant('BEN_TRE'),
                    description: translate.instant('THU_3'),
                    src: 'bentre'
                },
                {
                    id: '109',
                    name: 'VN',
                    title: translate.instant('VUNG_TAU'),
                    description: translate.instant('THU_3'),
                    src: 'vungtau'
                },
                {
                    id: '110',
                    name: 'VN',
                    title: translate.instant('BAC_LIEU'),
                    description: translate.instant('THU_3'),
                    src: 'baclieu'
                },
                {
                    id: '111',
                    name: 'VN',
                    title: translate.instant('DONG_NAI'),
                    description: translate.instant('THU_4'),
                    src: 'dongnai'
                },
                {
                    id: '112',
                    name: 'VN',
                    title: translate.instant('CAN_THO'),
                    description: translate.instant('THU_4'),
                    src: 'cantho'
                },
                {
                    id: '113',
                    name: 'VN',
                    title: translate.instant('SOC_TRANG'),
                    description: translate.instant('THU_4'),
                    src: 'soctrang'
                },
                {
                    id: '114',
                    name: 'VN',
                    title: translate.instant('TAY_NINH'),
                    description: translate.instant('THU_5'),
                    src: 'tayninh'
                },
                {
                    id: '115',
                    name: 'VN',
                    title: translate.instant('AN_GIANG'),
                    description: translate.instant('THU_5'),
                    src: 'angiang'
                },
                {
                    id: '116',
                    name: 'VN',
                    title: translate.instant('BINH_THUAN'),
                    description: translate.instant('THU_5'),
                    src: 'binhthuan'
                },
                {
                    id: '117',
                    name: 'VN',
                    title: translate.instant('VINH_LONG'),
                    description: translate.instant('THU_6'),
                    src: 'vinhlong'
                },
                {
                    id: '118',
                    name: 'VN',
                    title: translate.instant('BINH_DUONG'),
                    description: translate.instant('THU_6'),
                    src: 'binhduong'
                },
                {
                    id: '119',
                    name: 'VN',
                    title: translate.instant('TRA_VINH'),
                    description: translate.instant('THU_6'),
                    src: 'travinh'
                },
                {
                    id: '121',
                    name: 'VN',
                    title: translate.instant('BINH_PHUOC'),
                    description: translate.instant('THU_7'),
                    src: 'binhphuoc'
                },
                {
                    id: '122',
                    name: 'VN',
                    title: translate.instant('HAU_GIANG'),
                    description: translate.instant('THU_7'),
                    src: 'haugiang'
                },
                {
                    id: '123',
                    name: 'VN',
                    title: translate.instant('TIEN_GIANG'),
                    description: translate.instant('CHU_NHAT'),
                    src: 'tiengiang'
                },
                {
                    id: '124',
                    name: 'VN',
                    title: translate.instant('KIEN_GIANG'),
                    description: translate.instant('CHU_NHAT'),
                    src: 'kiengiang'
                },
                {
                    id: '125',
                    name: 'VN',
                    title: translate.instant('DA_LAT'),
                    description: translate.instant('CHU_NHAT'),
                    src: 'dalat'
                }
            ]
        },
        {
            label: translate.instant('TAI_XIU'),
            clsItem: "xosotaixiu",
            status: 0,
            collapse: false,
            tabMath: [4] as any,
            children: [
                {
                    id: '60',
                    name: 'MMC',
                    title: translate.instant('TAI_XIU_1_GIAY'),
                    description: translate.instant('MO_THUONG_NGAY_LAP_TUC'),
                    src: 'tx1giay'
                },
                {
                    id: '80',
                    name: 'tx1phut',
                    title: translate.instant('TAI_XIU_1_PHUT'),
                    description: translate.instant('MO_THUONG_MOI_1_PHUT'),
                    src: 'tx1phut'
                }
            ]
        },
        {
            label: translate.instant('XOC_DIA'),
            clsItem: "xosoxocdia",
            status: 2,
            collapse: false,
            tabMath: [4] as any,
            children: [
                {
                    id: '90',
                    name: 'MMC',
                    title: translate.instant('XOC_DIA_1_GIAY'),
                    description: translate.instant('MO_THUONG_NGAY_LAP_TUC'),
                    src: 'xocdia1giay'
                },
                {
                    id: '91',
                    name: 'tx1phut',
                    title: translate.instant('XOC_DIA_1_PHUT'),
                    description: translate.instant('MO_THUONG_MOI_1_PHUT'),
                    src: 'xocdia1phut'
                }
            ]
        },
        {
            label: translate.instant('BAU_CUA'),
            clsItem: "xosotaixiu",
            collapse: false,
            tabMath: [4] as any,
            status: 1,
            children: [
                {
                    id: '92',
                    name: 'MMC',
                    title: translate.instant('BAU_CUA_1_GIAY'),
                    description: translate.instant('MO_THUONG_NGAY_LAP_TUC'),
                    src: 'baucua1giay'
                },
                {
                    id: '93',
                    name: 'tx1phut',
                    title: translate.instant('BAU_CUA_1_PHUT'),
                    description: translate.instant('MO_THUONG_MOI_1_PHUT'),
                    src: 'baucua1phut'
                }
            ]
        }
    ];

    static GoIssueListMMC = [
        {
            num: 2,
            isSelect: true
        },
        {
            num: 5,
            isSelect: false
        },
        {
            num: 8,
            isSelect: false
        },
        {
            num: 10,
            isSelect: false
        },
        {
            num: 15,
            isSelect: false
        },
        {
            num: 20,
            isSelect: false
        }
    ];

    static thirdpartyGames = [
        {
            label: "Thể Thao",
            description: 'Thể Thao',
            src: 'thethao',
            page: 'sport2Page'
        },
        {
            label: "Live Casino",
            description: 'Live Casino',
            src: 'livecasino',
            page: 'livecasinoPage'
        },
        {
            label: "Mini Game",
            description: 'Mini Games',
            src: 'mini',
            page: 'bancaPage'
        }
        ,
        {
            label: "Game Bài",
            description: 'Trò Chơi',
            src: 'card',
            page: 'habaPage'
        },
        {
            label: "Slot Game",
            description: 'Trò Chơi',
            src: 'habagames',
            page: 'habaPage'
        },
        {
            label: "Bắn Cá",
            description: 'Bắn Cá',
            src: 'banca',
            page: 'bancaPage'
        }
    ];
}




// WEBPACK FOOTER //
// ./src/util/appConfig.ts